import fetcher from '@app/utils/fetcher';
import useConfiguration from '@store/hooks/useConfiguration';
import React, { MutableRefObject, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useSWR from 'swr';

import CategoryGridItem from './CategoryGridItem';
import NavigationAnchor from './NavigationAnchor';
import { ICategoryNode, INavigationItem, SidebarApiResponse } from './types';

interface IProps {
  navigationItems: INavigationItem[];
  divRef: MutableRefObject<any>;
  onClose: () => void;
}

export default function DefaultScreen(props: IProps) {
  const { t } = useTranslation();
  const { culture } = useConfiguration();

  const [selectedNode, setSelectedNode] = useState<ICategoryNode | undefined>();

  const { data, error } = useSWR<SidebarApiResponse>(`/${culture}/catalog/category-tree`, fetcher, {
    revalidateOnFocus: false,
  });

  const onClose = () => {
    setSelectedNode(undefined);
    props.onClose();
  };

  if (error) return <div>Chyba {error}</div>;
  if (!data) return <></>;

  return (
    <div
      className="w-full h-full flex flex-col bg-white z-10 shadow-md overflow-x-hidden"
      ref={props.divRef}>
      <div className="flex justify-between items-center bg-gradient-to-b from-primary-dark to-primary text-white p-4">
        <span className="text-xl font-bold font-heading uppercase">{t('Menu')}</span>
        <button className="p-1" role="button" onClick={onClose}>
          <i className="fa-solid fa-times fa-xl" />
        </button>
      </div>
      <div
        className={`grid relative ease-in-out duration-300 transition-transform ${
          selectedNode ? '-translate-x-full' : 'translate-x-0'
        }`}>
        {data.map(node => (
          <CategoryGridItem
            key={node.categoryId}
            onClick={n => setSelectedNode(n)}
            onBack={() => setSelectedNode(undefined)}
            selectedNodeId={selectedNode?.categoryId}
            {...node}
          />
        ))}

        {props.navigationItems.length > 0 && (
          <>
            <div className="w-full flex items-center py-3 px-4 text-sm font-medium text-gray-500 bg-gray-50">
              Ostatné stránky
            </div>
            {props.navigationItems.map(item => (
              <div key={item.url} className="flex items-center border-b border-gray-100">
                <NavigationAnchor
                  title={item.title}
                  href={item.url}
                  iconLeft={<i className="fa-solid fa-angle-right text-xs" />}>
                  <span>{item.title}</span>
                </NavigationAnchor>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
